import { getSubStepValues } from '#models/general/steps';
import Input from '#components/general/Input';
import { MEASURE_TYPES } from '#components/general/Input/components/Measure/constants';
import { getCheckboxesPercentagesRows } from '#models/general/fields/checkboxPercentage';

import { MASHING_FIELDS, NEW_PRODUCT_SUBSTEPS_IDS } from './constants';
import { getOperatorsForStep } from './utils';

const OPERATORS = {
  MARK_GIESLER: 'markGiesler',
  GORDON_MACKENZIE: 'gordonMackenzie',
  ROSS_HUGHES: 'rossHughes',
  NICKY_DOCHERTY: 'nickyDocherty',
  CHRIS_ANDERSON: 'chrisAnderson',
  SCOTT_STEWART: 'scottStewart',
  STEWART_CONNOR: 'stewartConnor',
  ALASTAIR_MACKAY: 'alastairMackay',
  DJ_CAMERON: 'djCameron',
  ALLY_FISHER: 'allyFisher',
  LOUIS_MACKENZIE: 'louisMackenzie'
};

export const MASHED_BY_OPTIONS = getOperatorsForStep(OPERATORS, 'Mashed');

export const getMashingFields = ({ values, errors }) => {
  const getMashingValues = getSubStepValues(NEW_PRODUCT_SUBSTEPS_IDS.MASHING, values, errors);
  return [
    ...getCheckboxesPercentagesRows(Object.values(MASHED_BY_OPTIONS), getMashingValues, values, 'Mashed'),
    {
      ...getMashingValues(MASHING_FIELDS.FIRST_TEMPERATURE),
      Component: Input,
      measure: MEASURE_TYPES.TEMPERATURE,
      noMargin: true
    },
    {
      ...getMashingValues(MASHING_FIELDS.SECOND_TEMPERATURE),
      Component: Input,
      measure: MEASURE_TYPES.TEMPERATURE,
      noMargin: true
    },
    {
      ...getMashingValues(MASHING_FIELDS.THIRD_TEMPERATURE),
      Component: Input,
      measure: MEASURE_TYPES.TEMPERATURE,
      noMargin: true
    },
    {
      ...getMashingValues(MASHING_FIELDS.GRAVITY),
      Component: Input,
      noMargin: true
    }
  ];
};
